import { MoreOutlined } from '@ant-design/icons';
import { Badge, Button, Checkbox, Col, Divider, Input, Layout, List, message, Modal, Popover, Radio, Row, Select, Space, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import LayoutHeader from "../../layouts/partials/LayoutHeader";
import { apiCall, apiDownload } from "../../utils/Api";
import PublisherCard from './PublisherCard';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import PublisherRow from './PublisherRow';
import { pluralize } from '../../utils/Utils';
import Html from '../../utils/Html';
import TitleResults from '../../components/title/TitleResults';
import Session, { useSession } from '../../utils/Session';
import PublisherISBNUploadFilter from './PublisherISBNUploadFilter';


export default function MyPublishersPage() {



    const [session, setSession] = useSession();

    const store = session?.available_corps.find(item => item.id === session?.corp_id)
    const store_name = store?.name || "";
    const [selected, setSelected] = useState("");
    const [imprint, setImprint] = useState({ publisher: {}, imprint: "", final: false });
    const [pubstockFilters, setPubstockFilters] = useState([])

    const [titlelist, setTitleList] = useState({ list: "", label: "", impression: false });

    const [trigger, setTrigger] = useState(Date.now());


    const [dragging, setDragging] = useState(false);

    const reset = () => {
        setImprint({ publisher: {}, imprint: "", final: false });
        setSelected("");
        setLP({ rows: [] })
        setImp({ rows: [] })
    }


    const hasPublisher = (id) => {
        const pubs = lp?.rows || []
        const publisherIds = new Set(pubs.map(pub => pub.id));
        return publisherIds.has(id);
    };


    const hasImprint = (id) => {

        const pubs = lp?.rows || []
        const imprintIds = new Set(
            pubs.flatMap(pub => (pub.imprints || []).map(imp => imp.id))
        );
        return imprintIds.has(id);
    };



    const onDrop = (data, target, imprint = "test") => {

        if (target === "raw") {
            if (Array.isArray(data?.item?.imprints) && data?.item?.imprints.length > 0) {
                const _arr = data?.item?.imprints.map(item => item.id);


                apiCall("publisher_imprint/unlinkPubImpFromMe", { pip_ids: _arr.join(",") }, (_s, _r) => {
                    if (_s) {
                        message.success("Publisher " + data.item.label + " removed successfully.");
                        setLP(prev => ({ ...prev, rows: [...prev.rows].filter(item => item.id !== data.id) }));
                    }
                })
            }
        } else {
            if (Array.isArray(data?.item?.imprints) && data?.item?.imprints.length > 0) {
                const _arr = data?.item?.imprints.map(item => item.id);
                apiCall("publisher_imprint/linkPubImpToMe", { pip_ids: _arr.join(",") }, (_s, _r) => {
                    if (_s) {


                        setLP(prev => {
                            const exists = prev.rows.some(r => r.id === data.item.id);

                            if (exists) {
                                message.error("Publisher " + data.item.label + " already added.");
                                return prev;
                            }

                            message.success("Publisher " + data.item.label + " added successfully.");
                            return { ...prev, rows: [...prev.rows, data.item] };
                        });
                    }
                })
            }
        }


        if (data.type === "search") {
            setPrefix(data?.id || "");
            setFilters(prev => ({ ...prev, isbn_prefix_filter: data?.id }));
        }


    };

    const [showMap, setShowMap] = useState(new Map());

    const toggleShow = (id) => {
        setShowMap(prev => {
            const next = new Map(prev);
            next.set(id, !prev.get(id));
            return next;
        });
    };


    const PubStockItem = (props) => {

        const { data = {}, titleCallback = () => { } } = props;
        const { id = "", label = "", type = "", title_count = "0" } = data;
        return (<div style={{ "padding": "4px 10px" }} className='float-flex c'>
            <small>{label}</small>
            <a onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                titleCallback(label)
            }}><small>{title_count}  {pluralize(title_count, "title", "s")}</small></a>
        </div>)
    }


    const PubItem = (props) => {

        const { prefix = "", dragging = "", setDragging = () => { }, data = {}, final = false, onDelete = () => { }, onRename = () => { }, onFinished = () => { }, callback = () => { }, titleCallback = () => { }, className = "", can_drag = true, type = "", is_prefix = false } = props;

        const {
            label = "",
            id = "",
            accept = "",
            imprints = [],
            status = "",
            count = null,
            imprint_count = null,
            title_count = null
        } = data;

        const show = showMap.get(prefix + id) || false;
        const { pubs = [], setPubs } = props;

        const getPubsFor = () => {


            let _obj = {
                key: prefixParams?.key,
                value: prefixParams?.value,
                prefix: id
            };

            apiCall("publisher_imprint/getPubsFor", _obj, (_s, _r) => {
                if (_s) {
                    if (_r.rows.length === 0) {
                        message.error("No pubstock");
                    }
                    setPubs(_r.rows);
                } else {
                    message.error(_r.error);
                }
            });
        };

        return (
            <div key={id} className={className + " bc"} style={{ "borderBottom": "1px solid" }}>
                <div style={{ "padding": "4px 10px" }} className='float-flex'>
                    <div onClick={() => { callback(data) }} style={{ "width": "100%" }}>
                        <div className='shim' />
                        <div><small><Space size={0} direction='vertical' ><Html className="pub-text c" html={label} />{(prefix === "fp" && hasPublisher(id)) && <div>*already picked</div>}</Space></small></div>
                        <div className='float-flex'>
                            <div>
                                {(is_prefix && <a onClick={() => getPubsFor()}>
                                    <small>Pubstock</small>
                                </a>)}
                                &nbsp;
                            </div>
                            <Space>
                                {(!is_prefix && <a onClick={(e) => {
                                    e.stopPropagation();
                                    toggleShow(prefix + id);
                                }}><small>{imprint_count} {pluralize(imprint_count, "imprint", "s")}</small></a>)}
                                <a onClick={(e) => {
                                    e.stopPropagation();
                                    titleCallback(data);
                                }}
                                ><small>{title_count} {pluralize(title_count, "title", "s")}</small></a>
                            </Space>
                        </div>
                    </div>
                </div>
                <div className={(show) ? 'expand' : "contract"} >
                    {(is_prefix && <div className='bc' style={{ "backgroundColor": "#88888811", borderTop: (pubs.length > 0) ? "1px solid" : "0px solid" }}>
                        {pubs.map(item => {
                            return <PubStockItem titleCallback={(e) => {
                                titleCallback(data, e);
                            }} data={item} />
                        })}
                    </div>)}

                    {(show &&
                        <div>

                            {(is_prefix && <>

                                {pubs.map(item => {
                                    return <PubStockItem final={final} data={item} />
                                })}

                            </>)}

                            {
                                imprints.map(item => {
                                    return (
                                        <PublisherRow item={item} id={item.id} dragging={dragging} setDragging={setDragging} accept={accept} type={type + "_imprint"} can_drag={can_drag} className={className}>
                                            <div>

                                                <ImprintItem prefix={prefix} final={final}

                                                    titleCallback={(e) => {
                                                        titleCallback(data, e.id);
                                                    }} callback={(e) => {
                                                        callback(data, e.id);
                                                    }} data={item} />
                                            </div>
                                        </PublisherRow>
                                    )
                                })
                            }
                        </div>
                    )}
                </div>
            </div>
        )
    }


    const ImprintItem = (props) => {

        const { final = false, data = {}, callback = () => { }, prefix = "", titleCallback = () => { }, onFinished = () => { }, onDelete = () => { }, onRename = () => { } } = props;

        const {
            label = "",
            id = "",
            type = "",
            status = "",
            count = null,
            title_count = null
        } = data;

        const is_finished = status.includes("finished");
        const [open, setOpen] = useState(false)

        return (
            <div className='imprint' style={{ "padding": "4px 0px" }}>
                <div className='bcg2' style={{ "height": "1px", "marginTop": "-4px", "opacity": "0.5" }}></div>
                <div className='shim' />
                <div style={{ "padding": "4px 10px" }} className='float-flex'>
                    <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); callback(data) }} style={{ "width": "100%" }}>
                        <div style={{ "margin": "-5px" }}><small><Space size={0} direction="vertical" ><Space size={10}><Badge style={{ "backgroundColor": "#00000088", "boxShadow": "none" }} dot /><em><Html className="pub-text c" html={label} /></em> </Space>{(prefix === "fp" && hasImprint(id)) && <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*already exists</div>}</Space></small></div>
                        <div className='float-flex'>
                            <div>&nbsp;</div>
                            <Space>
                                <a onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    titleCallback(data);
                                }}><small>{title_count}  {pluralize(title_count, "title", "s")}</small></a>
                            </Space>
                        </div>
                    </div>
                </div>
            </div>
        )
    }




    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        flag_filters: "",
        publisher_filter: "",
        imprint_filter: "",
        supplier_filter: "",
        isbn_prefix_filter: "",
        custom_isbn_filter_id: "",
        sortby: "count"
    })

    const [fp, setFP] = useState({ rows: [] })

    const toggleFlag = (_flag) => {
        if (_flag === filters.flag_filters) {
            _flag = ""
        }
        setFilters({ ...filters, "flag_filters": _flag })
    }



    const isUnset = () => {

        if (
            filters.publisher_filter === "" &&
            filters.imprint_filter === "" &&
            filters.supplier_filter === "" &&
            filters.isbn_prefix_filter === "" &&
            filters.custom_isbn_filter_id === "") {
            return true;
        } else {
            return false;
        }
    }

    const fetchPublisherImprints = () => {


        if (
            filters.publisher_filter === "" &&
            filters.imprint_filter === "" &&
            filters.supplier_filter === "" &&
            filters.isbn_prefix_filter === "" &&
            filters.custom_isbn_filter_id === "") {
            setFP({ ...fp, "rows": [] });
            return;
        }

        setLoading(true)
        apiCall("publisher_imprint/getFinalPublisherImprints", filters, (_status, _result) => {
            if (_status) {
                setFP(_result);
                setLoading(false)
            } else {
                message.error(_result.error)
            }
            setLoading(false)
        })

    }

    useEffect(fetchPublisherImprints, [filters, trigger]);


    const fetchPubstockFilters = () => {
        apiCall("publisher_imprint/getPubstockFilters", {}, (_s, _r) => {
            if (_s) {
                setPubstockFilters(_r);
            } else {
                message.error(_r.error)
            }
        })
    }
    useEffect(fetchPubstockFilters, [])

    const getClass = (_item, _final = false) => {

        let _c = "";
        const _status = _item?.status || "";

        if (_final) {
            if (_status.includes("moved") || _status.includes("finished")) {
                _c = "pub-moved";
            } else {
                _c = "pub-dirty";
            }
            if (_item?.id === selected?.id) {
                _c += " pub-selected";
            }
        } else {
            _c = "pub-raw";

        }
        return "pub " + _c;

    }


    const [prefix, setPrefix] = useState("")

    const finalPublisherFilters = (props) => {

        return (
            <div>
                <div style={{ "height": "50px" }} className='float-flex'>
                    <div className='c'>Candidate publishers</div>
                </div>
                <div style={{ "height": '1px', "margin": "0px -10px", "backgroundColor": "#88888833" }}>&nbsp;</div>
                <div className='shim' /><div className='shim' />

                <div><Input.Search enterButton onSearch={(e) => setFilters({ ...filters, "publisher_filter": e })} placeholder={'Publisher...'} allowClear size='small' /></div><div className='shim' />
                <div><Input.Search enterButton onSearch={(e) => setFilters({ ...filters, "imprint_filter": e })} placeholder={'Imprint...'} allowClear size='small' /></div><div className='shim' />
                <div><Input.Search className={(dragging === "search") ? "hover-highlight" : ""} value={prefix} onChange={(e) => setPrefix(e.target.value)} enterButton onSearch={(e) => setFilters({ ...filters, "isbn_prefix_filter": e })} placeholder={'ISBN Prefix...'} allowClear size='small' /></div><div className='shim' />
                <div>
                    <Select showSearch allowClear onChange={(e) => setFilters({ ...filters, "supplier_filter": (e) ? e : "" })} value={(filters.supplier_filter) ? filters.supplier_filter : null} placeholder="Pubstock filter..." size='small' style={{ "width": "100%" }}>
                        {pubstockFilters.map(item => {
                            return (<Select.Option key={item.id}><small>{item.label}</small></Select.Option>)
                        })}
                    </Select>
                </div>
                <div>
                    <PublisherISBNUploadFilter filters={filters} setFilters={setFilters} />
                </div>
                <div className='shim' />
                <div className='float-flex'>
                    <div>
                         {(fp?.rows.length === 500 && <div style={{"textAlign" : "center"}}><small>*Maximum 500 results reached</small></div>)}
                         
                    </div>
                    <div>
                        <Radio.Group onChange={(e) => setFilters({ ...filters, "sortby": e.target.value })} value={filters.sortby} size='small'>
                            <Radio value={"alpha"}><small>Alphabetical</small></Radio>
                            <Radio value={"count"}><small># Titles</small></Radio>
                            {/* <Radio value={"edited"}><small>Date Edited</small></Radio> */}
                        </Radio.Group>
                    </div>
                </div>
                <div className='shim' /><div className='shim' />
                <Spin spinning={loading}>
                    <div className='bc removing-border' style={{ "height": "calc(100vh - 488px)", "overflow": "auto", "overflowX": "hidden", "border": "1px solid", "borderRadius": "5px" }}>
                        {((fp?.rows.length === 0 && !loading && !isUnset()) && <div style={{ "textAlign": "center", "marginTop": "50px" }}>No matches found</div>)}
                        {((fp?.rows.length === 0 && !loading && isUnset()) && <div style={{ "textAlign": "center", "marginTop": "0px", "color": "#f00", "backgroundColor": "#ff0" }}>Please use a filter</div>)}
                        
                        {fp.rows.map(item => {
                            return (
                                <PublisherRow item={item} can_drag={true} dragging={dragging} setDragging={setDragging} id={item.id} onDrop={onDrop} >
                                    <PubItem prefix="fp" final={true} accept={["publisher", "raw"]} can_drag={false} className={getClass(item, true)}
                                        titleCallback={(e, imprint = false) => {
                                            if (imprint) {

                                                let _lbl = item.imprints.find(i => i.id === imprint);

                                                fetchTitlesFor(item, "finalImp", imprint, false, false, _lbl.label, filters.supplier_filter)
                                            } else {
                                                fetchTitlesFor(item, "finalPub", e.id, false, false, false, filters.supplier_filter)
                                            }
                                        }}

                                        callback={(e, imprint = false) => {
                                            setSelected({ ...e, imprint: imprint });
                                            setImprint({ publisher: e, final: true, imprint: imprint });
                                            if (imprint) {
                                                fetchPrefixes("finalImp", imprint);
                                            } else {
                                                fetchPrefixes("finalPub", e.id);
                                            }
                                        }} data={item} />
                                </PublisherRow>
                            )
                        })}
                       
                    </div>
                </Spin>
                <div className='shim' />

            </div>
        )
    }



    const [lpfilters, setLPFilters] = useState({
        publisher_filter: "",
        imprint_filter: "",
        supplier_filter: "",
        isbn_prefix_filter: "",
        sortby: "alpha" //  alpha count edited
    })

    const [lp, setLP] = useState({ rows: [] })
    const [lpLoading, setLPLoading] = useState(false);

    const getPubLinkedPublisherImprintsXls = () => {
        apiDownload({ ...lpfilters }, "publisher_imprint/getPubLinkedPublisherImprintsXls");
    }

    const fetchMyPublisherFilters = () => {

        setLPLoading(true)

        apiCall("publisher_imprint/getPubLinkedPublisherImprints", { ...lpfilters }, (_status, _result) => {
            if (_status) {
                setLP(_result);
                setLoading(false)
            } else {
                message.error(_result.error)
            }
            setLPLoading(false)
        })
    }

    useEffect(fetchMyPublisherFilters, [lpfilters, trigger])


    const myPublisherFilters = (props) => {

        return (
            <Spin indicator={<></>} spinning={false}>
                <div style={{ "height": "auto" }} className='float-flex'>
                    <div style={{ "flex": "1" }} className='c'>
                        <div>Publishers represented by: {store_name}</div>
                        <div className='float-flex'>
                            <div>{((lp?.publisher_count > 0) && <div style={{ "opacity": "0.7" }}>({lp?.publisher_count} Publishers, {lp?.title_count} Titles)</div>)}</div>
                            <div><Button onClick={() => getPubLinkedPublisherImprintsXls()} type='primary' className='mini-btn' style={{ "lineHeight": "15px" }} size='small'><small>Export to XLS</small></Button></div>
                        </div>
                        <div className='shim' /> <div style={{ "height": "1px" }} className='shim' />
                    </div>

                </div>
                <div style={{ "height": '1px', "margin": "0px -10px", "backgroundColor": "#88888833" }}>&nbsp;</div>
                <div className='shim' /><div className='shim' /><div className='shim' /><div className='shim' />
                <div><Input.Search enterButton onSearch={(e) => setLPFilters({ ...lpfilters, "publisher_filter": e })} placeholder={'Publisher...'} allowClear size='small' /></div><div className='shim' />
                <div><Input.Search enterButton onSearch={(e) => setLPFilters({ ...lpfilters, "imprint_filter": e })} placeholder={'Imprint...'} allowClear size='small' /></div><div className='shim' />
                <div>
                    <Select showSearch allowClear onChange={(e) => setLPFilters({ ...lpfilters, "supplier_filter": (e) ? e : "" })} value={(lpfilters.supplier_filter) ? lpfilters.supplier_filter : null} placeholder="Pubstock filter..." size='small' style={{ "width": "100%" }}>
                        {pubstockFilters.map(item => {
                            return (<Select.Option key={item.id}><small>{item.label}</small></Select.Option>)
                        })}
                    </Select>
                </div>
                <div className='shim' />
                <div className='shim' />
                <Spin spinning={lpLoading}>
                    <div className='bc dropping-border' style={{ "height": "calc(100vh - 414px)", "overflow": "auto", "overflowX": "hidden", "border": "1px solid ", "borderRadius": "5px" }}>

                        {((lp?.publisher_count === 0 && !lpLoading) && <div style={{ "textAlign": "center", "marginTop": "50px" }}>No matches found</div>)}
                        {lp.rows.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
                            return (
                                <PublisherRow dragging={dragging} type="raw" setDragging={setDragging} item={item} id={item.id} onDrop={(a, b) => onDrop(a, b, "got this")} >
                                    <PubItem prefix="lp" can_drag={true} dragging={dragging} setDragging={setDragging} id={item.id} type="raw" data={item} className={getClass(item, true)} titleCallback={(e, imprint = false) => {


                                        if (imprint) {

                                            let _lbl = item.imprints.find(i => i.id === imprint);

                                            fetchTitlesFor(item, "finalImp", imprint, false, false, _lbl.label, lpfilters.supplier_filter)
                                        } else {
                                            fetchTitlesFor(item, "finalPub", e.id, false, false, false, lpfilters.supplier_filter)
                                        }



                                    }} callback={(e, _imprint) => {
                                        setImprint({ publisher: e, final: false, imprint: _imprint });
                                        if (_imprint) {
                                            fetchPrefixes("rawImp", _imprint);
                                        } else {
                                            fetchPrefixes("rawPub", e.id);
                                        }
                                    }} />
                                </PublisherRow>
                            )
                        })}
                    </div>
                </Spin>
                <div className='shim' />
            </Spin>
        )
    }





    const [imp, setImp] = useState({ rows: [] })
    const [impLoading, setImpLoading] = useState(false);
    const [prefixParams, setPrefixParams] = useState();

    const [prefixSort, setPrefixSort] = useState("prefix");



    const updateStatusString = (status, finished) => {
        const parts = status.split(" ").filter(Boolean);
        const hasFinished = parts.includes("finished");

        if (finished && !hasFinished) {
            parts.push("finished");
        } else if (!finished && hasFinished) {
            parts.splice(parts.indexOf("finished"), 1);
        }

        return parts.join(" ");
    };

    function updateFinishedStatus({ key, value, finished }, rows) {

        const updatedRows = [...rows];

        const index = updatedRows.findIndex(row => {
            if (key === "pip_publisher") return row.label === value;
            if (key === "pip_id") return row.imprints.some(imp => imp.id === value);
            return false;
        });

        if (index === -1) return rows;

        const row = { ...updatedRows[index] };

        if (key === "pip_publisher") {
            row.status = updateStatusString(row.status, finished);
        } else if (key === "pip_id") {
            row.imprints = row.imprints.map(imp => {
                if (imp.id === value) {
                    return {
                        ...imp,
                        status: updateStatusString(imp.status, finished)
                    };
                }
                return imp;
            });
        }

        updatedRows[index] = row;
        return updatedRows;
    }


    const setFinishedFlagFor = (_type, _id, _finished = false) => {

        let _obj = {}

        switch (_type) {
            case "finalImp":
                _obj.key = "pip_id";
                break;
            case "finalPub":
                _obj.key = "pip_publisher";
                break;
        }

        _obj.value = _id;
        _obj.finished = _finished;

        apiCall("publisher_imprint/setFinishedFlagFor", _obj, (_s, _r) => {
            if (_s) {
                setFP({ ...fp, "rows": updateFinishedStatus(_obj, fp.rows) })
            } else {
                message.error(_r.error)
            }
        })

    }


    const fetchTitlesFor = (_data, _type, _id, _prefix = false, _pubstock = false, _imprint = false, _supplier_filter = "") => {



     


        setTitleList({ list: "", label: "", impression: false, pubstock: _pubstock })

        let _obj = {};
        let _impression = false;
        switch (_type) {
            case "rawImp":
                _obj.key = "pip_id";
                _impression = true;
                break;
            case "rawPub":
                _obj.key = "pip_publisher";
                break;
            case "finalImp":
                _obj.key = "pip_id";
                _impression = true;
                break;
            case "finalPub":
                _obj.key = "pip_publisher";
                break;
        }

        _obj.value = _id;

        if (_prefix) {
            _obj.prefix = _prefix;
        }

        if (_pubstock) {
            _obj.supplier = _pubstock;
        }

        if(_supplier_filter){
            _obj.supplier_filter = _supplier_filter; 
        }


        apiCall("publisher_imprint/getTitleListFor", _obj, (_s, _r) => {
            if (_s) {
                let t = { list: _r.id, label: _data?.label, impression: _impression, pubstock: _pubstock, prefix: _prefix, imprint: _imprint };
                console.log(t)
                setTitleList(t)
            } else {
                message.error(_r.error)
            }
        })

    }

    const fetchPrefixes = (_type, _id, _bypass = false) => {

    

        let _obj = {
            sortby: prefixSort,
            value: _id,
        }

        switch (_type) {
            case "rawImp":
                _obj.key = "pip_id";
                break;
            case "rawPub":
                _obj.key = "pip_publisher";
                break;
            case "finalImp":
                _obj.key = "pip_id";
                break;
            case "finalPub":
                _obj.key = "pip_publisher";
                break;
        }

        setImpLoading(true);
        if (_bypass) {
            _obj = _bypass;
        }

        setPrefixParams(_obj);



        apiCall("publisher_imprint/getPrefixesFor", _obj, (_status, _result) => {
            if (_status) {
                setImp(_result);
            } else {
                message.error(_result.error)
            }
            setImpLoading(false);
        })
    }

    const decodeEntities = (str = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    };


    const getType = (_type) => {

        let _r = "";
        switch (_type) {
            case "pipm_id":
                _r = "rawImp";
                break;
            case "pipm_publisher":
                _r = "rawPub";
                break;
            case "pip_id":
                _r = "finalImp";
                break;
            case "pip_publisher":
                _r = "finalPub";
                break;
        }

        return _r;

    }


    const getLabel = (_imprint) => {
        let _ret = "";

        if (_imprint?.imprint && Array.isArray(_imprint.publisher?.imprints)) {
            const match = _imprint.publisher.imprints.find(item => item.id === _imprint.imprint);
            if (match) {
                _ret = <>Prefixes for Publisher/Imprint: <br /><em>{decodeEntities(match.label)} / {decodeEntities(_imprint.publisher.label)}</em></>;
            } else {
                _ret = <>Prefixes for Publisher: <br /><em>{decodeEntities(_imprint.publisher.label)}</em></>;
            }
        } else {
            _ret = (_imprint?.publisher?.label) ? <>Prefixes for Publisher: <br /><em>{decodeEntities(_imprint?.publisher?.label)}</em></> : "Prefixes for Publisher";
        }


        return _ret;
    };

    const [pubsMap, setPubsMap] = useState(new Map());

    const publisherPrefixes = () => {



        return (
            <Spin indicator={<></>} spinning={!imprint?.publisher?.id}>
                <div style={{ "minHeight": "auto" }} className='float-flex'>
                    <div className='c'>
                        <div>{getLabel(imprint)}</div>
                        <div>{((imp.rows.length > 0) && <div style={{ "opacity": "0.7" }}>({imp.rows.length} Prefixes)</div>)}</div>
                    </div>
                </div>

                <div style={{ "height": '1px', "margin": "0px -10px", "backgroundColor": "#88888833" }}>&nbsp;</div>
                <div className='shim' /><div className='shim' /><div className='shim' /><div className='shim' />
                <div className='float-flex'>
                    <div>
                        <Radio.Group onChange={(e) => {
                            setPrefixSort(e.target.value)
                            fetchPrefixes({}, "", { ...prefixParams, "sortby": e.target.value });
                        }} value={prefixSort} size='small'>
                            <Radio value={"prefix"}><small>Prefix</small></Radio>
                            <Radio value={"title_count"}><small>Title count</small></Radio>
                        </Radio.Group>
                    </div>
                    <div>&nbsp;</div>
                </div>

                <div className='shim' />
                <Spin spinning={impLoading}>
                    <div className='bc' style={{ "height": "calc(100vh - 350px)", "overflow": "auto", "overflowX": "hidden", "border": "1px solid ", "borderRadius": "5px" }}>
                        {imp.rows.map(item => {
                            return (
                                <PublisherRow
                                    type="search" dragging={dragging} setDragging={setDragging} item={item} id={item.id} onDrop={onDrop} >
                                    <PubItem pubs={pubsMap.get(item.id) || []}
                                        setPubs={(rows) => {
                                            setPubsMap(prev => {
                                                const next = new Map(prev);
                                                next.set(item.id, rows);
                                                return next;
                                            });
                                        }}

                                        titleCallback={(e, pub_label = false) => {
                                            let _type = getType((imprint?.imprint) ? imprint.publisher.imprints[0].type : imprint.publisher.type);
                                            let _lbl = ""
                                            let _id = ""
                                            if (_type === "finalPub" || _type === "rawPub") {
                                                _lbl = imprint.publisher.label;
                                                _id = imprint.publisher.id; 
                                                
                                            } else {
                                                _lbl = imprint.imprint;
                                                _id = imprint.imprint; 
                                            }
                                            if (pub_label) {
                                                fetchTitlesFor(item, _type, _id, e.id, pub_label);
                                            } else {
                                                fetchTitlesFor(item, _type, _id, e.id);
                                            }
                                        }} is_prefix data={item} />
                                </PublisherRow>
                            )
                        })}
                    </div>
                </Spin>
                <div className='shim' />
            </Spin>
        )
    }

    return (
        <>
            <Layout className="layout" >
                <LayoutHeader
                    title={<div className='float-flex'><div>Publishers & Imprints</div>
                        <Space>
                            <div className='pub-dirty bc2' style={{ "boxShadow": "inset 0 0 2px #00000022", "borderRadius": "10px", "padding": "0px 15px" }}><small style={{ "fontSize": "12px", "lineHeight": "20px" }}>Data not verified</small></div>
                            <div className='pub-moved bc2' style={{ "boxShadow": "inset 0 0 2px #00000022", "borderRadius": "10px", "padding": "0px 15px" }}><small style={{ "fontSize": "12px", "lineHeight": "20px" }}>Data verified</small></div>

                        </Space>
                    </div>}
                />

                <Layout.Content style={{ "padding": "0px" }} >
                    <div style={{ "padding": "10px" }}>

                        <DndProvider backend={HTML5Backend}>
                            <Row gutter={10}>
                                <Col flex={"33%"}>
                                    <div>
                                        <PublisherCard dragging={dragging} imprint={prefixParams} className='bcg3' drop_type={["publisher", "search"]} id="publisher" onDrop={onDrop} >
                                            {myPublisherFilters()}
                                        </PublisherCard>
                                    </div>
                                </Col>
                                <Col flex={"33%"}>
                                    <div style={{ "opacity": 1, outline: (isUnset()) ? "2px solid #f00" : "none", "borderRadius": "3px" }}>
                                        <PublisherCard dragging={dragging} className='bcg3' drop_type={["raw", "search"]} id="raw" onDrop={onDrop} >
                                            {finalPublisherFilters()}
                                        </PublisherCard>
                                    </div>
                                </Col>
                                <Col flex={"33%"}>
                                    <div style={{ "opacity": (dragging === "publisher" || dragging === "raw" || dragging === "imprint") ? 0.5 : 1 }}>
                                        <PublisherCard drop_type="SEARCH" id="prefix" onDrop={onDrop} >
                                            {publisherPrefixes()}
                                        </PublisherCard>
                                    </div>
                                </Col>
                            </Row>
                        </DndProvider>
                    </div>
                    {(titlelist?.list &&
                        <div style={{ "margin": "20px" }}>
                            <TitleResults title={<div>Final Pub{(titlelist.imprint && <>/Imprint</>)}: {decodeEntities(titlelist.label)}{(titlelist.imprint && <>/{decodeEntities(titlelist.imprint)}</>)} {(titlelist?.pubstock && <div><small style={{ "opacity": "0.7" }}>Pubstock supplier: {decodeEntities(titlelist.pubstock)}</small></div>)} </div>} list={titlelist?.list} />
                        </div>
                    )}
                </Layout.Content>
            </Layout>
        </>
    )
}